import { useState } from 'react'
import { Anchor, Box, Group, Loader, Text } from '@mantine/core'
import { IconAlertTriangle, IconCheck } from '@tabler/icons-react'

import type { ProvisioningStep } from '../../../api/waf'

/**
 * O que o pedido já conseguiu fazer, uma linha por marco.
 *
 * Existe por causa do incidente de 10/08/2026: a tela dizia "Falha ao
 * provisionar … WAFUnavailableEntityException" — verdade, e inútil. O operador
 * não tinha como saber que o Web ACL JÁ EXISTIA e que tentar de novo era
 * seguro. Quem hesitava deixava o ALB desprotegido; quem insistia com outro
 * nome criava o segundo órfão.
 *
 * Não é log ao vivo: sem SSE, sem store efêmero. O que fica gravado serve à
 * tela E a quem for investigar depois.
 */
export function ProvisioningTimeline({ steps }: { steps: ProvisioningStep[] }) {
  if (!steps?.length) return null
  return (
    <Box mt="xs">
      {steps.map(s => (
        <PassoLinha key={s.id} passo={s} />
      ))}
    </Box>
  )
}

function PassoLinha({ passo }: { passo: ProvisioningStep }) {
  const [aberto, setAberto] = useState(false)
  return (
    <Group gap="xs" wrap="nowrap" align="flex-start">
      <Text size="xs" c="dimmed" ff="monospace" style={{ whiteSpace: 'nowrap' }}>
        {new Date(passo.created_at).toLocaleTimeString()}
      </Text>
      {passo.status === 'ok' && <IconCheck size={14} />}
      {/* Loader do Mantine, não IconLoader do tabler — aquele é SVG estático e
          o passo "em espera" ficava congelado (TASK-9817). */}
      {passo.status === 'wait' && <Loader size={14} />}
      {passo.status === 'error' && <IconAlertTriangle size={14} />}
      <Box>
        <Text size="xs">
          {passo.message}
          {passo.attempts > 1 ? ` — ${passo.attempts} tentativas` : ''}
        </Text>
        {/* O detalhe técnico (ARN, erro cru da AWS) fica ESCONDIDO por
         *  `display: none`, não por altura zero: `Spoiler`/`Collapse` do Mantine
         *  fecham com `height: 0 + overflow: hidden`, que o jsdom não considera
         *  invisível — o teste de "só atrás de ver detalhes" passaria falso e a
         *  regressão que ele existe para pegar entraria calada. */}
        {passo.detail && (
          <>
            <Anchor component="button" type="button" size="xs"
                    onClick={() => setAberto(a => !a)}>
              {aberto ? 'ocultar' : 'ver detalhes'}
            </Anchor>
            <Text size="xs" c="dimmed" ff="monospace"
                  style={{ display: aberto ? undefined : 'none', wordBreak: 'break-all' }}>
              {passo.detail}
            </Text>
          </>
        )}
      </Box>
    </Group>
  )
}
